import React, { useEffect, useState } from 'react'
import AOS from 'aos'

const Contacts = () => {
  const [values, setValues] = useState({
    message: '',
    name: '',
    email: '',
    phone: '',
    subject: '',
    sent: false,
    buttonText: 'Send Message',
    success: false,
    error: false
  })

  const { message, name, email, subject, phone, buttonText, success, error } =
    values

  const clickSubmit = (e) => {
    e.preventDefault()
    setValues({ ...values, buttonText: 'Sending...', success: true })
    showSuccessMessage()
  }

  const handleChange = (name) => (e) => {
    setValues({
      ...values,
      [name]: e.target.value,
      error: false,
      success: false,
      buttonText: 'Send Message'
    })
  }

  const showSuccessMessage = () =>
    success && (
      <div className='alert alert-info'>Thank you for contacting us.</div>
    )

  const showErrorMessage = () => (
    <div
      className='alert alert-danger'
      style={{ display: error ? '' : 'none' }}
    >
      {error}
    </div>
  )

  useEffect(() => {
    AOS.init({ once: true })
  }, [])

  return (
    <div className='w-full flex items-start justify-center flex-wrap pb-4 sm:pb-10 md:pb-12 lg:pb-16 px-4 lg:pl-10'>
      <div className='w-full sm:w-1/3 pb-8 sm:pb-0 sm:pl-0 lg:pl-10'>
        <h1 className='text-left text-oya-ghana-header-h3 lg:text-oya-ghana-header-h2 font-bold leading-snug'>
          Contact Us
        </h1>

        <h5 className='text-oya-ghana-header-h5 leading-loose'>Let’s Talk.</h5>

        {showSuccessMessage()}
        {showErrorMessage()}
      </div>
      <div className='w-full sm:w-2/3 lg:pr-20'>
        <form
          action=''
          className='w-full'
          onSubmit={clickSubmit}
          data-aos='fade-in'
          data-aos-duration='1200'
        >
          <div className='w-full flex justify-between flex-wrap mb-6'>
            <div className='w-full sm:w-1/2 sm:pr-3'>
              <label htmlFor='fullname'>Subject</label>
              <input
                type='text'
                id='subject'
                onChange={handleChange('subject')}
                value={subject}
                className='block w-full p-3 mt-4 border border-oya-ghana-border rounded'
                placeholder='Message Subject '
                required
              />
            </div>
            <div className='w-full sm:w-1/2 pt-4 sm:pl-3 sm:pt-0'>
              <label htmlFor='email'>Full Name</label>
              <input
                type='text'
                id='fullname'
                onChange={handleChange('name')}
                value={name}
                className='block w-full p-3 mt-4 border border-oya-ghana-border rounded'
                placeholder='Enter full name'
                required
              />
            </div>
          </div>
          <div className='w-full flex justify-between flex-wrap mb-6'>
            <div className='w-full sm:w-1/2 sm:pr-3'>
              <label htmlFor='fullname'>Phone Number</label>
              <input
                type='number'
                min={10}
                id='phone'
                onChange={handleChange('phone')}
                value={phone}
                className='block w-full p-3 mt-4 border border-oya-ghana-border rounded'
                placeholder='Enter phone number'
                required
              />
            </div>
            <div className='w-full sm:w-1/2 pt-4 sm:pl-3 sm:pt-0'>
              <label htmlFor='email'>Email</label>
              <input
                type='email'
                id='email'
                onChange={handleChange('email')}
                value={email}
                className='block w-full p-3 mt-4 border border-oya-ghana-border rounded'
                placeholder='Enter Email Address'
                req
              />
            </div>
          </div>

          <div className='w-full flex justify-between flex-wrap mb-6'>
            <div className='w-full mt-5'>
              <label htmlFor='phone' className='pb-2'>
                Message
              </label>
              <textarea
                rows={5}
                type='text'
                id='message'
                onChange={handleChange('message')}
                value={message}
                className='text-left w-full p-3 mt-2 border border-oya-ghana-border rounded'
                placeholder='Write your message here'
              />
            </div>
          </div>

          <div className='my-5'>
            <button
              type='submit'
              className='w-full sm:w-1/3 xl:w-1/4 bg-oya-ghana-green text-oya-ghana-header-h6 rounded-md py-2 text-white'
            >
              {buttonText}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Contacts
